<template>
  <div class="fault-container">
    <div class="menu-tab">
      <el-row>
        <el-button type="primary" size="mini" @click="addType"
          >添加故障类型</el-button
        >
        <!-- <el-button type="success" size="mini">取消全选</el-button>
        <el-button type="info" size="mini">删除</el-button>
        <el-select
          v-model="cateDetail"
          placeholder="选择分类"
          size="mini"
          style="margin-left: 20px"
          value-key="name"
        >
          <el-option
            v-for="item in cateList"
            :key="item.id"
            :label="item.name"
            :value="item"
          >
          </el-option>
        </el-select> -->
        <el-input
          placeholder="输入关键字进行过滤"
          v-model="filterText"
          size="mini"
          style="width: 200px; margin-left: 10px"
        >
        </el-input>
      </el-row>
    </div>
    <div class="list-content">
      <el-tree
        class="filter-tree"
        :data="data"
        :props="defaultProps"
        default-expand-all
        :filter-node-method="filterNode"
        ref="tree"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <template v-if="!data.code">
            {{ data.name }}
            <!-- <span style="margin-left: 10px"
              ><el-button type="text" class="colorRed" @click="addType"
                >添加</el-button
              ></span
            > -->
          </template>
          <template v-else>
            <span @click="openDetail(data)" class="waring-type-item">
              <span>{{ data.description || data.name }}</span>
              <span v-if="data.code">
                -- <span style="color:#cc6666;font-weight:700">{{ data.code }}</span>
              </span>
            </span>

            <!-- <span class="operating-btns">
              <el-button type="text">编辑</el-button>
              <el-button type="text">删除</el-button>
            </span> -->
          </template>
        </span>
      </el-tree>
    </div>

    <el-dialog
      :title="detail.name"
      :visible.sync="dialogVisibleTypeDetail"
      width="30%"
      :append-to-body="true"
    >
      <div>
        <div>
          <span>错误代码：</span>
          <span class="colorRed">{{ detail.code }}</span>
        </div>
        <div>
          <span>错误描述：</span>
          <span class="colorBlue">{{ detail.description }}</span>
        </div>
        <div>
          <span>解决方案：</span>
          <span class="colorOrange"
            ><p>{{ detail.solution }}</p></span
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibleTypeDetail = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="添加故障类型"
      :modal-append-to-body="false"
      :visible.sync="dialogVisible"
      width="30%"
      :destroy-on-close="true"
    >
      <div style="margin: 20px"></div>
      <el-form
        :label-position="labelPosition"
        label-width="80px"
        :model="formData"
        :rules="rules"
        ref="form"
      >
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" v-if="currentType == diaglogType.add"
          >确 定</el-button
        >
        <el-button type="primary" v-if="currentType == diaglogType.edit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Core from "@/libs/src/core";
const diaglogType = {
  add: "1",
  edit: "2",
};
export default {
  data() {
    return {
      diaglogType: diaglogType,
      currentType: "",
      filterText: "",
      Loading: false,
      dialogVisible: false,
      dialogVisibleTypeDetail: false,
      tableData: [],
      rules: {
        name: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
      },
      labelPosition: "top",
      formData: {
        name: "",
        CraftType: 0,
      },
      search: "",
      selectList: [],
      data: [],
      detail: {},
      defaultProps: {
        children: "child",
        label: "name",
      },
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.ops = Core.getProvider("DPC").operation;
    this.init();
  },
  methods: {
    // 打开详情
    openDetail(detail) {
      this.detail = detail;
      this.dialogVisibleTypeDetail = true;
    },
    addType() {
      this.currentType = diaglogType.add;
      //   this.dialogVisible = true;
    },
    filterNode(value, data) {
      console.log(data);
      if (!value) return true;
      if (data.code) {
        return (data.code.toLocaleUpperCase().indexOf(value.toLocaleUpperCase()) !== -1||data.name.toLocaleUpperCase().indexOf(value.toLocaleUpperCase()) !== -1);
      } else {
        return true;    
      }
    },
    async init() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let res = await this.ops.getAllOpsFaultType();
      console.log(res);

      let treeList = [];
      res.forEach((item) => {
        let obj = {
          child: [],
          name: item.faultTypeName,
          typeId: item.faultTypeId,
        };
        item.child.forEach((ch) => {
          let obj2 = {
            child: [],
            name: ch.faultTypeName,
            typeId: ch.faultTypeId,
            parentId: ch.parentId,
          };
          ch.opsFaults.forEach((opsItem) => {
            obj2.child.push({
              code: opsItem.code,
              description: opsItem.description,
              name: opsItem.opsFaultTypeName,
              typeId: opsItem.opsFaultTypeId,
              solution: opsItem.solution,
            });
          });
          obj.child.push(obj2);
        });
        treeList.push(obj);
      });
      console.log(treeList);
      this.data = treeList;
      loading.close();
    },
    selectChange(e) {
      this.selectList = e;
    },
  },
};
</script>
<style lang="scss" scoped>
.fault-container {
  .list-content {
    margin-top: 10px;
    height: 90vh;
    overflow: auto;
  }
}
.operating-btns {
  margin-left: 50px;
}
.colorRed {
  color: #cc6666;
}
.colorBlue {
  color: #409eff;
}
.colorOrange {
  color: #e6a23c;
}
.waring-type-item{
    padding: 10px;
    transition: all 0.3s;
    &:hover{
        background-color: rgba($color: #008585, $alpha: 0.7);
        color:#fff;
        border-radius: 5px;
    }
}
</style>